export const getAgentIDsFromAgentList = (agentList) =>
  (agentList || []).map((agent) => agent?.uniqueId);

export const isAgentActive = (agent) => {
  if (!agent) return false;

  if (
    agent.isActiveForTwentyMinutes() &&
    !agent.isRegistered &&
    !agent.isOutOfSync()
  ) {
    return true;
  }

  if (!agent.isActive && !agent.isActiveForTwentyMinutes()) {
    return false;
  }

  return agent.isActive;
};
